export class Media {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly url: string,
  ) {}
}
